export const ConfigObject = (function () {
  var config = {
    DATE_TIME_PATTERN: 'yyyy-MM-dd HH:mm:ss',
    DATE_PATTERN: 'yyyy-MM-dd'
  };

  function save(configs) {
    config = { ...config, ...configs };
  }

  function get() {
    return config;
  }

  return {
    save: save,
    get: get,
  };
})();
